<template>
  <v-app>
    <v-main>
      <router-view />
    </v-main>
    <global-snackbar></global-snackbar>
    <global-dialog></global-dialog>
  </v-app>
</template>

<script>
// import { db } from "@/firebase";
// import { collection, getDocs } from "firebase/firestore/lite";
import GlobalDialog from "@/components/GlobalDialog.vue";
import GlobalSnackbar from "@/components/GlobalSnackbar.vue";
export default {
  name: "App",
  components: { GlobalDialog, GlobalSnackbar },
  async created() {
    // let snapshot = await getDocs(collection(db, "artprofiles"));
    // console.log(snapshot.docs.map((doc) => doc.data()));
  },
  data: () => ({
    //
  }),
};
</script>
